// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import $ from 'jquery'
import api from './api/index.js'
import echarts from 'echarts'
import vuescroll from 'vuescroll';
import 'vuescroll/dist/vuescroll.css';
import axios from 'axios';
import "babel-polyfill";
import store from './store/index.js';
import utils from './utils/index.js'
import echartswordcloud from 'echarts-wordcloud';
import Confirm from '@/components/confirm/confirm'
// import ElementUI from 'element-ui';
import { Button,Radio,Checkbox,CheckboxGroup,RadioGroup,Input,Tree, Slider,Table, TableColumn,Progress,Switch} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.prototype.$confirm = Confirm.install;
import drowDowns from '@/components/form/drowDown/index'
Vue.use(drowDowns);
Vue.use(Button);
Vue.use(Radio);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(RadioGroup);
Vue.use(Input);
Vue.use(Tree);
Vue.use(Slider);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Progress)
Vue.use(Switch)
// import md5 from 'js-md5'

Vue.use(vuescroll);
var baseUrl = process.env.BASE_URL
Vue.prototype.$utils = utils
Vue.prototype.$api = api
Vue.prototype.$echarts = echarts
Vue.prototype.$axios=axios
Vue.prototype.$baseUrl = baseUrl//挂在全局配置变量
Vue.prototype.$newsIsRead = '#808080'//全局已读颜色

// 监听方案选择变化
Vue.prototype.resetSetItem = function (key, newVal) {
    if (key === 'planStorage') {

        // 创建一个StorageEvent事件
        var newStorageEvent = document.createEvent('StorageEvent');
        const storage = {
            setItem: function (k, val) {
                sessionStorage.setItem(k, val);

                // 初始化创建的事件
                newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);

                // 派发对象
                window.dispatchEvent(newStorageEvent)
            }
        }
        return storage.setItem(key, newVal);
    }
}

Vue.config.productionTip = false
//神策数据埋点配置
let url = '';
if(process.env.NODE_ENV === 'development'){
    url = 'http://sjcj.gsdata.cn/sa?project=default'
}else{
    url = 'https://sjcj.gsdata.cn/sa?project=production'
    // url = 'https://sjcj.gsdata.cn/sa?project=default'
}
var sensors = require('sa-sdk-javascript');
sensors.init({
    server_url: url,
    is_track_single_page:true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
    use_client_time:true,
    send_type:'beacon',
    show_log:false,
    heatmap: {
        //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
        clickmap:'default',
        //是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
        scroll_notice_map:'not_collect'
    }
});
// 注册公共属性
sensors.registerPage({
	platform_type: "Web",
    product_name: "清博舆情",
    product_vision: "v5.0",
});
sensors.quick('autoTrack'); //用于采集 $pageview 事件。
Vue.prototype.$sensors = sensors
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})


//  检测方案跳转
router.beforeEach((to, from, next) => {
    // 登录检测
    let trialInfoType = parseInt(sessionStorage.getItem('trialInfoType'));
    let host = window.location.host;
    if (to.meta.title) {
        document.title = to.meta.title
    }else{
        next()
    }
    if(host === 'yuqing_new.gsdata.cn'  || host === 'oldyuqing.gsdata.cn' || host === 'yuqing.gsdata.cn' || host === 'yuqing_old_test.gsdata.cn'){//线上
        if (to.matched.some(res => res.meta.requireAuth)) { // 验证是否需要登录
            let cooke = document.cookie.indexOf("_gsdataCL=");
            if (cooke != -1) { // 查询本地存储信息的方案信息
                //用户页面逗留统计
                api.post('open/menu-click-statistics',{menuName:to.meta.title,menuPath:'vindex'+to.path},r =>{})
                next();
            } else {
                window.location.href="https://u1.gsdata.cn/member/login?url=http://"+host+""+baseUrl+"/yuYingGather";

            }
        } else {
            next();
        }
    }
    if(trialInfoType === 1 && to.path !== ''+baseUrl+'/fillInTrial'){
        if(to.path.indexOf('fillInTrial') < 0){
            utils.alertText('此功能需先填写试用信息后才能使用');
        }
        next({
            path: ''+baseUrl+'/fillInTrial'
        });
		return;
    }else{
        next();
    }
    //方案检测
    if (to.matched.some(res => res.meta.planCut)) { // 验证是否需要方案
        if (sessionStorage.getItem('planStorage')) { // 查询本地存储信息的方案信息
            next();
        } else {
            utils.alertText('当前没有方案，请先创建方案！');
            next({
                path: ''+baseUrl+'/buildSolution'
            });
        }
    } else {
        next();
    }
});



// WEBPACK FOOTER //
// ./src/main.js